import { memo, useEffect, useState } from 'react';
import Navigation from './navigation';
import NavBar from './navbar';

import { useSelector } from 'react-redux';

import { getCurrentEmployer, getAssociatedEmployer } from './selectors/employers';

import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from './constants/employerTypes';

export default memo(function MainTabNavBar(props) {
  const employer = useSelector(getCurrentEmployer);
  const associatedEmployer = useSelector(getAssociatedEmployer);

  const isAirforceStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isAirforcePatient = associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isMedRecruiter =
    employer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER ||
    associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;

  const [navbarButtons, setNavbarButtons] = useState(null);
  useEffect(() => {
    const nextNavbarButtons = isAirforceStaff
      ? NavBar.milStaffButtons
      : isAirforcePatient
        ? NavBar.milPatientButtons
        : isMedRecruiter
          ? NavBar.medRecruiterButtons
          : NavBar.consumerButtons;
    if (navbarButtons !== nextNavbarButtons) {
      setNavbarButtons(nextNavbarButtons);
      Navigation.setButtons(nextNavbarButtons, props.componentId);
    }
  }, [isAirforceStaff, isAirforcePatient, isMedRecruiter, props.componentId, navbarButtons]);

  return null;
});
